// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from "../Utils/AppLogoImg.js";

var dashboardCommonJS = require("../../js/dashboardCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

const SmartDevice = (appsParam) => {

  useEffect(() => {            
    
    dashboardCommonJS.actualizarControlDispositivo(appsParam.smartDevice, "")    
    comprobarDisponibilidadFuncionesAC()
    
  }, [appsParam.smartDevice]);
  
  const dispositivosSensor = ["SENSOR_TEMPERATURA","SENSOR_HUMEDAD","MONITOR_CONSUMO","SENSOR_PUERTA_VENTANA","PENDIENTE_INTEGRAR","SENSOR_VOC", "SENSOR_CH2O", "SENSOR_CO2"]    
  const dispositivosPulsador = ["PULSADOR","TV","EQUIPO_SONIDO","LUZ*PULSADOR","PROYECTOR*PULSADOR","TV_BOX","LAVADORA*PULSADOR"]  
  const dispositivosPersiana = ["PERSIANA"]  
  const dispositivosClima = ["ESTUFA","TERMOSTATO","AIRE_ACONDICIONADO","AIRE_ACONDICIONADO*DIRECTO","CALENTADOR_PISCINA"]  
  //const dispositivosSwitch = []  => CUALQUIER OTRO QUE NO ESTÉ ARRIBA

  const monitoresConInterruptor = ["SHELLY"]

  function setearLiteralControlEstufa(tipoDispositivo){
    
    var literal = ""

    if(tipoDispositivo === "ESTUFA"){literal = "Potencia"}
    else if(tipoDispositivo === "AIRE_ACONDICIONADO"){literal = "Temperatura"}
    else if(tipoDispositivo === "CALENTADOR_PISCINA"){literal = "Temperatura"}
    else if(tipoDispositivo === "PERSIANA"){literal = "Apertura"}

    return literal
  }

  function setearLectura(dispositivo){
    
    var lecturaAMostrar = ""      
    
    try{
      
      var marcaDispositivo = dispositivo.MarcaDispositivo
      var tipoDispositivo = dispositivo.TipoDispositivo
      var estadoDispositivo = dispositivo.Estado
      var IdDispositivo = dispositivo.IdDispositivo
      var lecturaActual = dispositivo.Valor
      
      if(tipoDispositivo.includes("LAVADORA")){
        if(estadoDispositivo === "on"){
          lecturaAMostrar = "Lista para lavar"
          document.getElementById("pulsador"+IdDispositivo).removeAttribute('disabled');            
        }
        else if(estadoDispositivo === "running"){
          lecturaAMostrar = "Lavando"
          document.getElementById("pulsador"+IdDispositivo).setAttribute('disabled','disabled');            
        }          
        else{
          lecturaAMostrar = "Control remoto desactivado"
          document.getElementById("pulsador"+IdDispositivo).setAttribute('disabled','disabled');            
        }          
      }
      else if(lecturaActual !== "N/A"){ 
        lecturaAMostrar = lecturaActual 

        if(tipoDispositivo === "ENCHUFE_MONITOR"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "ENCHUFE"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "MONITOR_CONSUMO"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "MONITOR_CONSUMO_INTERRUPTOR"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "INTERRUPTOR"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "PULSADOR"){lecturaAMostrar = new Intl.NumberFormat('en-DE').format(lecturaAMostrar) + " W"}
        else if(tipoDispositivo === "TEMPERATURA"){lecturaAMostrar = lecturaAMostrar + " °C"}
        else if(tipoDispositivo === "HUMEDAD"){lecturaAMostrar = lecturaAMostrar + " %"}
        else if(tipoDispositivo === "TERMO"){lecturaAMostrar = lecturaAMostrar + " °C"}
        else if(tipoDispositivo === "SENSOR_TEMPERATURA"){lecturaAMostrar = lecturaAMostrar + " °C"}      
        else if(tipoDispositivo === "SENSOR_HUMEDAD"){lecturaAMostrar = lecturaAMostrar + " %"}      
        else if(tipoDispositivo === "SENSOR_VOC"){lecturaAMostrar = lecturaAMostrar + " ppm"}      
        else if(tipoDispositivo === "SENSOR_CH2O"){lecturaAMostrar = lecturaAMostrar + " mg/m³"}      
        else if(tipoDispositivo === "SENSOR_CO2"){lecturaAMostrar = lecturaAMostrar + " ppm"}      
        else if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){
          if(estadoDispositivo === "on"){ lecturaAMostrar = "Abierto" }
          else {lecturaAMostrar = "Cerrado"}        
          lecturaAMostrar = lecturaAMostrar + " | Batería: "+lecturaActual+"%"      
        }            
        else if( (tipoDispositivo === "AIRE_ACONDICIONADO*DIRECTO") || (tipoDispositivo === "TERMOSTATO") || (tipoDispositivo === "CALENTADOR_PISCINA") ){ 
          lecturaAMostrar = lecturaAMostrar + " °C"         
          document.getElementById("lectura"+IdDispositivo).innerHTML = lecturaAMostrar
          document.getElementById("spanLiteralControles"+IdDispositivo).className = document.getElementById("spanLiteralControles"+IdDispositivo).className.replaceAll(" hidden", "") + " hidden"
        }
        else if( (tipoDispositivo === "PERSIANA") && ( marcaDispositivo === "SHELLY") ){lecturaAMostrar = lecturaAMostrar + " %"}        
      }
      else{ 

        if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){
          if(estadoDispositivo === "on"){ lecturaAMostrar = "Abierto" }
          else {lecturaAMostrar = "Cerrado"}          
        }
        else{
          lecturaActual = "" 
        }
        
      }
    }      
    catch(error){}

    return lecturaAMostrar
  }

  function obtenerMensajeError(marcaAplicacion){
    var mensaje = ""

    if( marcaAplicacion === "ARISTON" ){
      mensaje = "Dispositivo inoperativo, prueba a desenchufarlo durante 10 minutos y vuévelo a conectar."
    }
    else if( marcaAplicacion === "ECOFORESTCONTROL" ){
      mensaje = "Dispositivo inoperativo, prueba a desenchufarlo durante 10 minutos y vuévelo a conectar."
    }
    else{
      mensaje = "Tengo problemas con esta aplicación, pulsa aquí para más información."
    }

    return mensaje
  }

  function comprobarDisponibilidadFuncionesAC(){

    try{

      //Compruebo disponibilidad
      var modosOperacionActuales = document.getElementById("ModosOperacionAC"+appsParam.smartDevice.IdDispositivo).value.split("·")[1]   
      
      if(modosOperacionActuales.includes("1|")){ 
        document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "")
      } 
      else{
        document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "") + " hidden"
      }

      if(modosOperacionActuales.includes("4|")){ 
        document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "")
      } 
      else{
        document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "") + " hidden"
      }

      if(modosOperacionActuales.includes("off")){ 
        document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "")
      } 
      else{
        document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className.replaceAll(" hidden", "") + " hidden"
      }

      //Y actualizo estados      
      dashboardCommonJS.actualizarEstadoFrontAC(appsParam.smartDevice.IdDispositivo, appsParam.smartDevice.Estado)      

    }
    catch(error){}

  }

  function cambiarModoOperacionAC(modo){

    var modosOperacionActuales = document.getElementById("ModosOperacionAC"+appsParam.smartDevice.IdDispositivo).value.split("·")[1]   
    var elementosModosOperacionActuales = modosOperacionActuales.split("#") 
    var elementosModosOperacion = ""

    for(var x=0; x < elementosModosOperacionActuales.length; x++){ 

      elementosModosOperacion = elementosModosOperacionActuales[x].split("|")

      if(modo === "FRIO"){
        if(elementosModosOperacion[0] === "1"){ //Codigo frio encontrado, lo ejecuto          
          document.getElementById("ModosOperacionAC"+appsParam.smartDevice.IdDispositivo).value = "FRIO·" + modosOperacionActuales
          document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo).className + " loading"
          dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)
          break
        }
      }
      else if(modo === "CALOR"){
        if(elementosModosOperacion[0] === "4"){ //Codigo frio encontrado, lo ejecuto          
          document.getElementById("ModosOperacionAC"+appsParam.smartDevice.IdDispositivo).value = "CALOR·" + modosOperacionActuales
          document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo).className + " loading"
          dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)
          break
        }
      }
      else if(modo === "OFF"){ 
        if(elementosModosOperacion[0] === "off"){ //Codigo frio encontrado, lo ejecuto          
          document.getElementById("ModosOperacionAC"+appsParam.smartDevice.IdDispositivo).value = "off·" + modosOperacionActuales
          document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className = document.getElementById("botonApagarAC"+appsParam.smartDevice.IdDispositivo).className + " loading"
          dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)
          break
        }
      }
    }
  }
  
  function obtenerTemperaturaAC(modo){

    var temperatura = ""

    try{
      var modosOperacionActuales = appsParam.smartDevice.Valor.split("·")[1]   
      var elementosModosOperacionActuales = modosOperacionActuales.split("#") 
      var elementosModosOperacion = ""

      for(var x=0; x < elementosModosOperacionActuales.length; x++){ 

        elementosModosOperacion = elementosModosOperacionActuales[x].split("|")

        if(modo === "FRIO"){
          if(elementosModosOperacion[0] === "1"){ //Codigo frio encontrado, lo ejecuto          
            temperatura = elementosModosOperacion[1]
            break
          }
        }
        else if(modo === "CALOR"){
          if(elementosModosOperacion[0] === "4"){ //Codigo frio encontrado, lo ejecuto          
            temperatura = elementosModosOperacion[1]
            break
          }
        }
      }
    }
    catch(error){console.log(error)}

    return temperatura + " °C"

  }
  
  function verMasInformacionError(marcaDispositivo){

    localStorage.setItem("appErrorDirectLink", marcaDispositivo)
    window.location="/InstallationConfiguration/Devices"

  }

  return ( 

    <React.Fragment key={"SDF"+appsParam.smartDevice.IdDispositivo}>
      { appsParam.smartDevice.TipoDispositivo === "ESCENA" ?

        <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
          <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
          <dl>
            <dd>{appsParam.smartDevice.Nombre}</dd>
            <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{appsParam.smartDevice.Valor}</dt>
          </dl>
          <div className="vertical gap-02">
            <button id={"pulsador"+appsParam.smartDevice.IdDispositivo} className="button tertiary size-s on-off rounded" ><span className="material-icon" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}>power_settings_new</span></button>
          </div>
        </li>

      :
      
        [ (appsParam.smartDevice.MarcaDispositivo === "BROADLINK") && (dispositivosClima.includes(appsParam.smartDevice.TipoDispositivo)) ?
          
          [ appsParam.smartDevice.Valor !== "" ?          
            <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item vertical gap-01">
              <div className="horizontal gap-03 vertical-center fill">
                <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                <dl className="vertical gap-02">
                  <dd className="size-l">
                    <div className="horizontal gap-02">
                      <span className="size-l">{appsParam.smartDevice.Nombre}</span>
                    </div>
                  </dd>
                </dl>
                <button id={"botonApagarAC"+appsParam.smartDevice.IdDispositivo} className="button tertiary size-s on-off rounded hidden" onClick={() => cambiarModoOperacionAC("OFF")}>
                  <span className="material-icon">power_settings_new</span>
                  <span id={"literalBotonApagarAC"+appsParam.smartDevice.IdDispositivo} className="size-s">Apagar</span>                  
                </button>
                <a href="https://www.fevergy.com/pdf/BROADLINK_AC.pdf" target="_blank" rel="noopener noreferrer" className="vertical center"><span className="material-icon">settings</span></a>
              </div>
              <fieldset className="radio multiple horizontal fill">
                <input type="radio" id={"frio"+appsParam.smartDevice.IdDispositivo} value="frio" name={"frio"+appsParam.smartDevice.IdDispositivo}/>
                <label id={"botonEncenderFrioAC"+appsParam.smartDevice.IdDispositivo} className="vertical vertical-center fill hidden" htmlFor={"frio"+appsParam.smartDevice.IdDispositivo} onClick={() => cambiarModoOperacionAC("FRIO")}>
                  <span className="vertical gap-02 center">                  
                    <span className="horizontal gap-02 center">
                      <span className="material-icon ">ac_unit</span>
                      <span className="size-s uppercase">Frío</span>
                    </span>
                    <span id={"temperaturaFrio"+appsParam.smartDevice.IdDispositivo} className="size-s">{obtenerTemperaturaAC("FRIO")}</span>                  
                  </span>
                </label>          
                <input type="radio" id={"calor"+appsParam.smartDevice.IdDispositivo} value="calor" name={"calor"+appsParam.smartDevice.IdDispositivo}/>
                <label id={"botonEncenderCalorAC"+appsParam.smartDevice.IdDispositivo} className="vertical center fill hidden" htmlFor={"calor"+appsParam.smartDevice.IdDispositivo} onClick={() => cambiarModoOperacionAC("CALOR")}>
                  <span className="vertical gap-02 center">                  
                    <span className="horizontal gap-02 center">
                      <span className="material-icon ">light_mode</span>
                      <span className="size-s uppercase">Calor</span>
                    </span>
                    <span id={"temperaturaCalor"+appsParam.smartDevice.IdDispositivo} className="size-s">{obtenerTemperaturaAC("CALOR")}</span>                  
                  </span>
                </label>
              </fieldset>
              <input id={"ModosOperacionAC"+appsParam.smartDevice.IdDispositivo} type="text" className=" hidden" defaultValue={appsParam.smartDevice.Valor}></input>
            </li>          
          :
            <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
              <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
              <dl className="vertical fill">
                <dd className="size-l">{appsParam.smartDevice.Nombre}</dd>
                <dt className="size-m">Pendiente de configurar</dt>
              </dl>
              <a href="https://www.fevergy.com/pdf/BROADLINK_AC.pdf" target="_blank" rel="noopener noreferrer"><span className="material-icon">settings</span></a>
            </li>
          ]
          
          :      

          [ (appsParam.smartDevice.Estado.split("·")[0] === "on") || (appsParam.smartDevice.Estado.split("·")[0] === "running") ?                
            [ dispositivosPersiana.includes(appsParam.smartDevice.TipoDispositivo) ?
              <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                <dl>
                  <dd>{appsParam.smartDevice.Nombre}</dd>
                  { (appsParam.smartDevice.MarcaDispositivo.includes("SHELLY")) ?
                    <dt className="horizontal gap-02">
                      <span id={"spanLiteralControles"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLiteralControlEstufa(appsParam.smartDevice.TipoDispositivo)}</span>
                      <button id={"bajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("bajar"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)-20))}><span className="material-icon">remove</span></button>
                      <span id={"lectura"+appsParam.smartDevice.IdDispositivo}>{setearLectura(appsParam.smartDevice)}</span>
                      <button id={"subir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("subir"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)+20))}><span className="material-icon">add</span></button>
                    </dt>
                  :
                    <React.Fragment key={"NR"+appsParam.smartDevice.IdDispositivo}/>
                  }
                </dl>
                <div className="vertical gap-02">
                  <button id={"botonSubir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-s blind closed hidden" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}><span className="material-icon"></span></button>
                  <button id={"botonBajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-s blind open" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}><span className="material-icon"></span></button>
                </div>
              </li>
            :

              [ dispositivosSensor.includes(appsParam.smartDevice.TipoDispositivo) && (!monitoresConInterruptor.includes(appsParam.smartDevice.MarcaDispositivo) || (appsParam.smartDevice.IdDispositivo.includes("T-")) ) ?             
                <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                  <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                  <dl className="vertical fill">
                    <dd className="size-l">{appsParam.smartDevice.Nombre}</dd>
                    <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                  </dl>
                </li>            
              :

                [ dispositivosPulsador.includes(appsParam.smartDevice.TipoDispositivo) ? 

                  <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                    <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                    <dl>
                      <dd>{appsParam.smartDevice.Nombre}</dd>
                      { appsParam.smartDevice.TipoDispositivo.includes("LAVADORA") ?
                        <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                      :
                        [appsParam.smartDevice.Valor !== "N/A" ?
                          <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                        :
                          <React.Fragment key={"NR"+appsParam.smartDevice.IdDispositivo}/>
                        ]
                      }
                    </dl>
                    <div className="vertical gap-02">                      
                      <button id={"pulsador"+appsParam.smartDevice.IdDispositivo} className="button tertiary size-s on-off rounded" ><span className="material-icon" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}>power_settings_new</span></button>
                    </div>
                  </li>

                :

                  <li key={"li"+appsParam.smartDevice.IdDispositivo} id={"li"+appsParam.smartDevice.IdDispositivo} className="check multiple toggle devices full-bleed with-divider green">          
                    <input type="checkbox" id={"checkbox"+appsParam.smartDevice.IdDispositivo} onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)} defaultChecked/>          
                    <label className="icon-wrapper" htmlFor={"checkbox"+appsParam.smartDevice.IdDispositivo}>            
                    <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                      <dl className="vertical fill">
                        <dd className="size-l">{appsParam.smartDevice.Nombre}</dd>       

                        { dispositivosClima.includes(appsParam.smartDevice.TipoDispositivo) ?
                        <>
                          <dt className="horizontal gap-02">
                            <span id={"spanLiteralControles"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLiteralControlEstufa(appsParam.smartDevice.TipoDispositivo)}</span>
                            <button id={"bajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("bajar"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)-1))}><span className="material-icon">remove</span></button>
                            <span id={"lectura"+appsParam.smartDevice.IdDispositivo}>{setearLectura(appsParam.smartDevice)}</span>
                            <button id={"subir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("subir"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)+1))}><span className="material-icon">add</span></button>
                          </dt>
                        </>
                        :
                          <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                        }            

                      </dl>                
                    </label>
                  </li>                 
                ]        
              ]
            ]
          :
            [ appsParam.smartDevice.Estado.split("·")[0] === "off" || (appsParam.smartDevice.Estado.split("·")[0] === "running") ?                     

              [ dispositivosPersiana.includes(appsParam.smartDevice.TipoDispositivo) ?
                <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                  <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                  <dl>
                    <dd>{appsParam.smartDevice.Nombre}</dd>
                    { (appsParam.smartDevice.MarcaDispositivo.includes("SHELLY")) ?
                      <dt className="horizontal gap-02">
                        <span id={"spanLiteralControles"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLiteralControlEstufa(appsParam.smartDevice.TipoDispositivo)}</span>
                        <button id={"bajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("bajar"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)-20))}><span className="material-icon">remove</span></button>
                        <span id={"lectura"+appsParam.smartDevice.IdDispositivo}>{setearLectura(appsParam.smartDevice)}</span>
                        <button id={"subir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("subir"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)+20))}><span className="material-icon">add</span></button>
                      </dt>
                    :
                      <React.Fragment key={"NR"+appsParam.smartDevice.IdDispositivo}/>
                    }
                  </dl>
                  <div className="vertical gap-02">
                    <button id={"botonSubir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-s blind closed" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}><span className="material-icon"></span></button>
                    <button id={"botonBajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-s blind open hidden" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}><span className="material-icon"></span></button>
                  </div>
                </li>
              :
                [ ( dispositivosSensor.includes(appsParam.smartDevice.TipoDispositivo) && (!monitoresConInterruptor.includes(appsParam.smartDevice.MarcaDispositivo)) ) || (appsParam.smartDevice.IdDispositivo.includes("T-"))? 
                  <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                    <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                    <dl className="vertical fill">
                      <dd className="size-l">{appsParam.smartDevice.Nombre}</dd>
                      <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                    </dl>
                  </li>
                :

                  [ dispositivosPulsador.includes(appsParam.smartDevice.TipoDispositivo) ? 

                      <li key={"li"+appsParam.smartDevice.IdDispositivo} className="list-item">
                        <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                        <dl>
                          <dd>{appsParam.smartDevice.Nombre}</dd>
                          { appsParam.smartDevice.TipoDispositivo.includes("LAVADORA") ?
                            <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                          :
                            [appsParam.smartDevice.Valor !== "N/A" ?
                              <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                            :
                              <React.Fragment key={"NR"+appsParam.smartDevice.IdDispositivo}/>
                            ]
                          }
                        </dl>
                        <div className="vertical gap-02">
                          <button id={"pulsador"+appsParam.smartDevice.IdDispositivo} className="button tertiary size-s on-off rounded"><span className="material-icon" onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}>power_settings_new</span></button>
                        </div>
                      </li>

                    :

                      <li key={"li"+appsParam.smartDevice.IdDispositivo} id={"li"+appsParam.smartDevice.IdDispositivo} className="check multiple toggle devices full-bleed with-divider blue-300">          
                        <input type="checkbox" id={"checkbox"+appsParam.smartDevice.IdDispositivo} onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)}/>            
                        <label className="icon-wrapper" htmlFor={"checkbox"+appsParam.smartDevice.IdDispositivo}>              
                          <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                          <dl className="vertical fill">
                            <dd className="size-l">{appsParam.smartDevice.Nombre}</dd> 

                            { dispositivosClima.includes(appsParam.smartDevice.TipoDispositivo) ?
                            <>
                              <dt className="horizontal gap-02">
                                <span id={"spanLiteralControles"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLiteralControlEstufa(appsParam.smartDevice.TipoDispositivo)}</span>
                                <button id={"bajar"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("bajar"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)-1))}><span className="material-icon">remove</span></button>
                                <span id={"lectura"+appsParam.smartDevice.IdDispositivo}>{setearLectura(appsParam.smartDevice)}</span>
                                <button id={"subir"+appsParam.smartDevice.IdDispositivo} className="button tertiary rounded size-xxs" onClick={() => dashboardCommonJS.modificarValorDispositivo("subir"+appsParam.smartDevice.IdDispositivo,appsParam.smartDevice,(parseInt(document.getElementById("lectura"+appsParam.smartDevice.IdDispositivo).innerHTML)+1))}><span className="material-icon">add</span></button>
                              </dt>
                            </>
                            :
                              <dt id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m">{setearLectura(appsParam.smartDevice)}</dt>
                            }      

                          </dl>                      
                        </label>
                      </li>
                  ]
                ]                
              ]
            :                    
            <li key={"li"+appsParam.smartDevice.IdDispositivo} id={"li"+appsParam.smartDevice.IdDispositivo} className="check multiple devices full-bleed with-divider offline ">          
              <input type="checkbox" id={"checkbox"+appsParam.smartDevice.IdDispositivo} onClick={() => dashboardCommonJS.actualizarEstadoDispositivo(appsParam.smartDevice.MarcaDispositivo,appsParam.smartDevice.IdDispositivo,appsParam.smartDevice.TipoDispositivo)} disabled/>            
              <label key={"label"+appsParam.smartDevice.IdDispositivo} className="icon-wrapper" htmlFor={"checkbox"+appsParam.smartDevice.IdDispositivo}>              
                <a href={generalCommonJS.obtenerURLAplicacionDeTerceros(appsParam.smartDevice.MarcaDispositivo)} target="_blank" rel="noopener noreferrer"><figure className="avatar size-m"><AppLogoImg key={"appLogo"+appsParam.smartDevice.id} aplicacion={appsParam.smartDevice.MarcaDispositivo}/></figure></a>
                <dl className="vertical fill">
                  <dd className="size-l">{appsParam.smartDevice.Nombre}</dd>          
                  
                  { appsParam.smartDevice.TipoDispositivo === "SERVIDOR_CAIDO" ?
                    <dt key={"dtsc"+appsParam.smartDevice.IdDispositivo} id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m error" onClick={() => verMasInformacionError(appsParam.smartDevice.MarcaDispositivo)}>{obtenerMensajeError(appsParam.smartDevice.MarcaDispositivo)}</dt>
                  :
                  
                    [ appsParam.smartDevice.TipoDispositivo === "PENDIENTE_INTEGRAR" ?
                      <React.Fragment key={"pInt"+appsParam.smartDevice.IdDispositivo}/>
                      :
                      <dt key={"dtok"+appsParam.smartDevice.IdDispositivo} id={"lectura"+appsParam.smartDevice.IdDispositivo} className="size-m error">Dispositivo sin conexión</dt>
                    ]

                  }              

                </dl>
              </label>
            </li>      
            ]
          ]

        ]     
      }

    </React.Fragment>
  )    
}

export default SmartDevice